/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Per_MonthInputs */

const en_cp_per_month = /** @type {(inputs: Cp_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const id_cp_per_month = /** @type {(inputs: Cp_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/bulan`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Cp_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_per_month = /** @type {((inputs?: Cp_Per_MonthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Per_MonthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_per_month(inputs)
	return en_cp_per_month(inputs)
});